import { sendEvent } from '@core/analytics'
import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions } from '@core/store'

import { addToCollectionStore, type TAddToCollectionAudio } from '../store/addToCollectionStore'

/**
 * Imperative open/close seam for the shared add-to-collection dialog. The real trigger (audio-card /
 * audio-hero) will call `open(audio)` once those migrate; the dialog view event fires in the
 * container on show, so it isn't tied to the opener.
 */
export const useAddToCollection = () => {
    const actions = useActions({
        setAudio: addToCollectionStore.actions.setAudio,
        openModal: modalStore.actions.open,
        closeModal: modalStore.actions.close,
    })

    const open = (audio: TAddToCollectionAudio) => {
        actions.setAudio(audio)
        actions.openModal(DIALOG_IDS.addToCollection)
        sendEvent({ name: 'collection_add_audio_click', payload: { audio: audio.id } })
    }

    const close = () => {
        actions.closeModal()
        actions.setAudio(null)
    }

    return { open, close }
}
